/* Existing sale runtime. Halloween presentation does not change checkout prices. */
(function (global) {
  'use strict';
  var HALLOWEEN = Object.freeze({startsAt: '2026-10-10T23:44:16Z', endsAt: '2026-10-18T13:00:00Z'});
  var OFFER = 'SAVE UP TO 30% WITH BUNDLE SAVINGS';
  var SUPPORT = 'EXTRA 20% OFF STOREWIDE · stacks with eligible bundle savings';
  var END_LABEL = 'Ends Sunday 18 October at 11:59 pm (Sydney time).';
  function instant(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(value)) return NaN;
    return Date.parse(value);
  }
  function windowState(config, now) {
    var start = instant(config && config.startsAt), end = instant(config && config.endsAt);
    var valid = Number.isFinite(start) && Number.isFinite(end) && end > start && Number.isFinite(now);
    return {phase: !valid ? 'invalid' : now < start ? 'before' : now < end ? 'active' : 'expired',
      startMs: start, endMs: end, remainingMs: valid ? Math.max(0, end - now) : 0};
  }
  function isHalloween(sale) {
    return !!sale && sale.title === 'Halloween Special' && Number(sale.percent_off) === 20 && instant(sale.ends_at) === instant(HALLOWEEN.endsAt);
  }
  function remaining(ms) {
    var seconds = Math.max(0, Math.ceil(ms / 1000));
    return Math.floor(seconds / 86400) + 'd ' + Math.floor(seconds % 86400 / 3600) + 'h ' + Math.floor(seconds % 3600 / 60) + 'm ' + seconds % 60 + 's';
  }
  function mount(win, doc) {
    if (!doc) return null;
    if (doc.__ccfSaleWindow) return doc.__ccfSaleWindow;
    var sale = null, leases = [], owned = [], classes = [], clock = null, destroyed = false, phase = 'invalid', boundaryTimer = null;
    function all(selector) { return Array.prototype.slice.call(doc.querySelectorAll(selector)); }
    // Liquid can be served from cache. Initial sale markup stays hidden until a
    // fresh feed or a valid legacy end instant permits it.
    all('[data-ccf-announcement-sale]').forEach(function(node){node.hidden=true;});
    all('[data-ccf-sale]').forEach(function(node){node.hidden=true;});
    function lease(node, property, value) {
      if (!node) return;
      if (leases.some(function(x){ return x.node === node && x.property === property; })) return;
      leases.push({node:node, property:property, before:node[property], applied:value}); node[property] = value;
      if(property==='hidden' && value===true && node.style) {
        leases.push({node:node,style:'display',before:node.style.getPropertyValue('display'),priority:node.style.getPropertyPriority('display'),applied:'none'});
        node.style.setProperty('display','none','important');
      }
    }
    function addClass(node, name) {
      if (!node || node.classList.contains(name)) return;
      node.classList.add(name); classes.push({node:node,name:name});
    }
    function attribute(node, name, value) {
      if (!node || leases.some(function(x){return x.node===node && x.attribute===name;})) return;
      leases.push({node:node,attribute:name,before:node.getAttribute(name),applied:value});
      if(value===null)node.removeAttribute(name);else node.setAttribute(name,value);
    }
    function copyBefore(node, text, tag) {
      if (!node || !node.parentNode || node.getAttribute('data-ccf-halloween-owned')==='true' || owned.some(function(x){return x.__ccfOriginal === node;})) return;
      var copy = doc.createElement(tag || node.tagName.toLowerCase());
      copy.className = node.className; copy.textContent = text;
      copy.setAttribute('data-ccf-halloween-owned', 'true'); copy.__ccfOriginal = node;
      node.parentNode.insertBefore(copy, node); owned.push(copy); lease(node, 'hidden', true);
    }
    function clear() {
      owned.forEach(function(node){ node.remove(); }); owned = [];
      leases.forEach(function(x){
        if(x.style){if(x.node.style.getPropertyValue(x.style)===x.applied && x.node.style.getPropertyPriority(x.style)==='important'){if(x.before)x.node.style.setProperty(x.style,x.before,x.priority);else x.node.style.removeProperty(x.style);}}
        else if(x.attribute){if(x.node.getAttribute(x.attribute)===x.applied){if(x.before===null)x.node.removeAttribute(x.attribute);else x.node.setAttribute(x.attribute,x.before);}}
        else if (x.node[x.property] === x.applied) x.node[x.property] = x.before;
      }); leases = [];
      classes.forEach(function(x){ x.node.classList.remove(x.name); }); classes = [];
      clock = null;
    }
    // Integer Shopify price units from the established Liquid price renderer.
    // Existing compare-at prices and set-saving badges remain untouched.
    function campaignPrices() {
      all('[data-ccf-campaign-cents]').forEach(function(node){
        var cents=Number(node.getAttribute('data-ccf-campaign-cents'));
        var currency=node.getAttribute('data-ccf-campaign-currency');
        if(!Number.isSafeInteger(cents)||cents<=0||!currency||!win.Intl)return;
        var formatter;
        try{formatter=new win.Intl.NumberFormat(doc.documentElement.lang||'en-AU',{style:'currency',currency:currency,currencyDisplay:'narrowSymbol'});}catch(e){return;}
        var finalCents=cents-Math.round(cents*20/100);
        var prefix=node.getAttribute('data-ccf-campaign-from')==='true'?'From ':'';
        var text=prefix+formatter.format(finalCents/100);
        var block=owned.find(function(x){return x.__ccfCampaignPriceFor===node;});
        if(!block){
          block=doc.createElement('span');block.className='ccf-campaign-price';
          block.setAttribute('data-ccf-halloween-owned','true');block.__ccfCampaignPriceFor=node;
          var current=doc.createElement('strong');current.className='ccf-campaign-price__current';
          var badge=doc.createElement('span');badge.className='ccf-campaign-price__badge';badge.textContent='EXTRA 20% at checkout';
          block.append(current,badge);node.appendChild(block);owned.push(block);
        }
        var current=block.querySelector('strong');if(current.textContent!==text)current.textContent=text;
        addClass(node,'ccf-campaign-price-active');
      });
    }
    function present() {
      addClass(doc.body, 'ccf-halloween-window');
      all('[data-ccf-announcement-sale]').forEach(function(node){
        copyBefore(node, OFFER + ' · ' + SUPPORT, node.tagName.toLowerCase());
        var copy = owned.find(function(x){return x.__ccfOriginal === node;});
        if (copy) {copy.hidden = false; if(copy.tagName === 'A') copy.href = '/collections/all';}
      });
      all('[data-ccf-sale]').forEach(function(node){
        lease(node, 'hidden', false); addClass(node, 'ccf-halloween-surface');
        var link=node.querySelector('.ccf-sale-banner__link');if(link)lease(link,'href','/collections/all');
        all('[data-ccf-sale] .ccf-sale-banner__offer').forEach(function(offer){ copyBefore(offer, OFFER); });
      });
      all('.ccf-hero, .ccf-studio-hero, [data-ccf-sale-spotlight]').forEach(function(node){addClass(node, 'ccf-halloween-surface');});
      all('[data-ccf-halloween-art]').forEach(function(hero){
        attribute(hero,'aria-labelledby',null);attribute(hero,'aria-label','Halloween Special');
        var media = hero.querySelector('.ccf-hero__media, .ccf-studio-hero__showcase');
        if (!media || owned.some(function(x){return x.__ccfMedia === media;})) return;
        var url = hero.getAttribute('data-ccf-halloween-art');
        if (!url) return;
        Array.prototype.slice.call(media.children).forEach(function(node){lease(node, 'hidden', true);});
        var art = doc.createElement('img'); art.__ccfMedia = media;
        art.setAttribute('data-ccf-halloween-owned','true'); art.className = 'ccf-halloween-approved-art';
        art.src = url; art.alt = 'Five original blue Halloween cookie cutter and stamp pairs. Save up to 30% with bundle savings; extra 20% off storewide.';
        art.width = 1080; art.height = 1080; media.appendChild(art); owned.push(art);
      });
      all('.ccf-hero__copy > .ccf-theme-heading').forEach(function(node){copyBefore(node, 'Halloween Special');});
      all('.ccf-hero__copy > .ccf-theme-copy').forEach(function(node){copyBefore(node, OFFER + '. ' + SUPPORT + '. ' + END_LABEL, 'div');});
      all('.ccf-studio-hero__heading').forEach(function(node){copyBefore(node, 'Halloween Special');});
      all('.ccf-studio-hero__text').forEach(function(node){copyBefore(node, OFFER + '. ' + SUPPORT + '. ' + END_LABEL, 'div');});
      all('.ccf-hero-titleplate__art, .ccf-hero-titleplate__meta, .ccf-hero-titleplate__rail, .ccf-hero-titleplate__trace').forEach(function(node){lease(node,'hidden',true);});
      all('[data-ccf-sale-title]').forEach(function(node){copyBefore(node, OFFER);});
      all('[data-ccf-sale-text]').forEach(function(node){copyBefore(node, SUPPORT + '. ' + END_LABEL, 'div');});
      all('[data-ccf-sale-kicker], [data-ccf-sale-note]').forEach(function(node){lease(node, 'hidden', true);});
      if (!clock) {
        var price = doc.querySelector('product-info .price, .product__info-container .price');
        if (price && price.parentNode) {
          clock = doc.createElement('section'); clock.className = 'ccf-campaign-countdown ccf-halloween-surface';
          clock.setAttribute('data-ccf-halloween-owned','true'); clock.setAttribute('aria-label', 'Halloween Special');
          var title = doc.createElement('p'); title.className = 'ccf-campaign-countdown__offer'; title.textContent = 'EXTRA 20% OFF STOREWIDE';
          var support = doc.createElement('p'); support.className = 'ccf-campaign-countdown__support'; support.textContent = 'Stacks with eligible bundle savings.';
          var time = doc.createElement('time'); time.setAttribute('datetime', HALLOWEEN.endsAt); time.setAttribute('data-ccf-halloween-clock','true');
          // Static expiry wording remains accessible; rapidly changing seconds are visual only.
          time.setAttribute('aria-hidden','true');
          var end = doc.createElement('span'); end.className = 'ccf-campaign-countdown__end'; end.textContent = 'Ends 18 Oct · 11:59 pm Sydney';
          var meta = doc.createElement('div'); meta.className = 'ccf-campaign-countdown__meta'; meta.append(time,end);
          var pumpkin = doc.createElement('span'); pumpkin.className = 'ccf-campaign-countdown__pumpkin'; pumpkin.setAttribute('aria-hidden','true'); pumpkin.textContent = '🎃';
          clock.append(title,support,meta,pumpkin); price.insertAdjacentElement('afterend',clock); owned.push(clock);
        }
      }
    }
    function update() {
      if (destroyed) return;
      var state = windowState(HALLOWEEN, win.Date.now());
      var active = isHalloween(sale) && sale.active === true && state.phase === 'active';
      var next = active ? 'active' : state.phase === 'active' ? 'invalid' : state.phase;
      if (active) {
        present(); campaignPrices();
        all('[data-ccf-halloween-clock]').forEach(function(node){node.textContent = 'Ends in ' + remaining(state.remainingMs);});
        all('[data-ccf-sale-countdown]').forEach(function(node){if(node.closest('[data-ccf-sale]'))node.textContent = remaining(state.remainingMs);});
      } else {
        clear();
        // Keep the original dated sale banner functional for other campaigns.
        all('[data-ccf-sale]').forEach(function(node){
          var title=node.getAttribute('data-sale-title'), percent=Number(node.getAttribute('data-sale-percent'));
          var end=instant(node.getAttribute('data-sale-ends-at'));
          if (title && title !== 'Halloween Special' && percent > 0 && end > win.Date.now()) {
            lease(node,'hidden',false);
            var count=node.querySelector('[data-ccf-sale-countdown]');if(count)count.textContent=remaining(end-win.Date.now());
          }
        });
      }
      if (next !== phase) {
        phase = next;
        if (win.CustomEvent) doc.dispatchEvent(new win.CustomEvent('ccf:sale-window', {detail:{phase:phase}}));
      }
      manager.phase = phase;
      return {phase:phase, startMs:state.startMs,endMs:state.endMs,remainingMs:state.remainingMs};
    }
    function visible() {update();}
    function armBoundary() {
      if (destroyed) return;
      if (boundaryTimer !== null) win.clearTimeout(boundaryTimer);
      var now=win.Date.now(), state=windowState(HALLOWEEN,now);
      var next=state.phase==='before'?state.startMs:state.phase==='active'?state.endMs:null;
      boundaryTimer=next===null?null:win.setTimeout(function(){boundaryTimer=null;update();armBoundary();},Math.min(2147483647,Math.max(0,next-now)));
    }
    var priceObserver = win.MutationObserver ? new win.MutationObserver(function(){if(!destroyed && phase==='active')campaignPrices();}) : null;
    if(priceObserver && doc.body)priceObserver.observe(doc.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-ccf-campaign-cents','data-ccf-campaign-currency']});
    var manager = {setSale:function(value){sale=value; return update();},update:update,phase:phase,destroy:function(){
      destroyed=true;if(priceObserver)priceObserver.disconnect();clear();win.clearInterval(timer);if(boundaryTimer!==null)win.clearTimeout(boundaryTimer);win.removeEventListener('pageshow',visible);win.removeEventListener('focus',visible);doc.removeEventListener('visibilitychange',visible);doc.removeEventListener('shopify:section:load',visible);doc.removeEventListener('variant:change',visible);delete doc.__ccfSaleWindow;
    }};
    doc.__ccfSaleWindow = manager;
    win.addEventListener('pageshow',visible);win.addEventListener('focus',visible);doc.addEventListener('visibilitychange',visible);doc.addEventListener('shopify:section:load',visible);doc.addEventListener('variant:change',visible);
    var timer=win.setInterval(update,1000); update();armBoundary();return manager;
  }
  global.CCFSaleWindow = {windowState:windowState,isHalloween:isHalloween,mount:mount,HALLOWEEN:HALLOWEEN};
  if (global.document) {
    var mounted=mount(global,global.document);
    if(global.__ccfHalloweenSale)mounted.setSale(global.__ccfHalloweenSale);
  }
})(typeof window !== 'undefined' ? window : globalThis);
